import React, { useEffect, useMemo, useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";
import Card from '../controls/Card';
import ContainerTwo from '../base/ContainerTwo';
import { useToast } from '../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { GetAllByUser } from '../../configurations/crud/opdCentersCrud';
import { Dashboard } from '../../configurations/crud/reportCrud';
import moment from 'moment';
import StatusContainer from '../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../configurations/enums/EType';
import Getbalance from './rechargeHistory/Getbalance';
import { HiDocumentReport } from "react-icons/hi";
import Select from '../controls/Select';
import { FaClinicMedical, FaUserPlus, FaUserCheck } from "react-icons/fa";
import { FiRefreshCcw, FiSearch, FiCalendar, FiPrinter } from "react-icons/fi";
import { HiOutlineSquares2X2, HiOutlineTag } from "react-icons/hi2";
import useGlobalLoader from '../../configurations/useGlobalLoader';
import Empty from '../controls/Empty';
import { IsMobileEnv } from '../../configurations/initUrls';

const TODAY = new Date();
const MONTH_START = TODAY

export default function DashBoard() {
    const { start, end } = useGlobalLoader()
    const [searchType, setSearchType] = useState(0);
    const [centerData, setCenterData] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(0);
    const initReport = {
        confirmedGlobal: [],
        confirmedSource: [],
        confirmedType: [],
        registeredGlobal: [],
    }
    const [reportData, setReportData] = useState(initReport);

    const toast = useToast()
    const [loding, setLoding] = useState(false)

    const [value, setValue] = useState({
        startDate: MONTH_START,
        endDate: TODAY
    });

    useEffect(() => {
        getReport()
        getAllOpdCenters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUser()
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    if (mdata.data.length > 0)
                        setCenterData(mdata.data);
                } else {
                    setCenterData([]);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch(() => {
                setCenterData([]);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    function getReport() {
        // validate before starting the loader so we never leave it running
        if (searchType == 1 && selectedCenter == 0) {
            toast.open("Please select center", <MdErrorOutline />, "danger")
            return;
        }
        setLoding(true);
        start()
        Dashboard({
            fromDate: moment(new Date(value.startDate)).format("MM/DD/YYYY"),
            toDate: moment(new Date(value.endDate)).format("MM/DD/YYYY"),
            centerId: searchType == 1 ? selectedCenter : 0,
            isCenter: searchType
        })
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    if (searchType == 0)
                        setReportData(mdata.global);
                    else
                        setReportData(mdata.center);
                } else {
                    setReportData(initReport);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch(() => {
                setReportData(initReport);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    const doRefresh = () => {
        getReport()
        getAllOpdCenters();
    }

    const doPrint = () => {
        window.print();
    }

    const selectedCenterName = searchType == 1
        ? (centerData.find(c => c.id == selectedCenter)?.centerName || "—")
        : "All Centers";

    /* ---------- derived summary numbers ---------- */
    const summary = useMemo(() => {
        const sum = (arr) => (arr || []).reduce((s, i) => s + (i.count || 0), 0);
        return {
            registered: sum(reportData.registeredGlobal),
            confirmed: sum(reportData.confirmedGlobal),
            sources: (reportData.confirmedSource || []).length,
            types: (reportData.confirmedType || []).length,
        };
    }, [reportData]);

    const dateLabel = `${moment(new Date(value.startDate)).format("DD MMM")} – ${moment(new Date(value.endDate)).format("DD MMM YYYY")}`;

    return (
        <ContainerTwo>
            {/* ================= Print styles ================= */}
            <style>{`
                .print-only { display: none; }

                @media print {
                    @page { size: A4; margin: 10mm 12mm; }
                    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    .no-print { display: none !important; }
                    .print-only { display: block !important; }
                }

                /* ---- compact print document ---- */
                .pr-doc { font-family: Arial, Helvetica, sans-serif; color: #111827; font-size: 11px; line-height: 1.35; }

                .pr-header { display: flex; align-items: flex-end; justify-content: space-between; border-bottom: 3px solid #111827; padding-bottom: 6px; }
                .pr-title { font-size: 20px; font-weight: 800; letter-spacing: -0.3px; margin: 0; }
                .pr-sub { font-size: 10px; color: #6b7280; text-transform: uppercase; letter-spacing: 1px; margin: 2px 0 0; }
                .pr-meta { text-align: right; font-size: 10px; color: #374151; }
                .pr-meta div { margin-top: 1px; }
                .pr-meta b { color: #111827; }

                .pr-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px; margin: 10px 0 12px; }
                .pr-stat { border: 1px solid #d1d5db; border-radius: 6px; padding: 6px 8px; }
                .pr-stat .k { font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.8px; color: #6b7280; }
                .pr-stat .v { font-size: 17px; font-weight: 800; line-height: 1.1; }

                .pr-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
                .pr-section { break-inside: avoid; page-break-inside: avoid; }
                .pr-section h3 { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; margin: 0 0 4px; padding: 3px 6px; background: #111827; color: #ffffff; border-radius: 3px; }

                .pr-table { width: 100%; border-collapse: collapse; }
                .pr-table th { font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.6px; color: #6b7280; text-align: left; padding: 3px 6px; border-bottom: 1.5px solid #111827; }
                .pr-table th.num, .pr-table td.num { text-align: right; font-variant-numeric: tabular-nums; }
                .pr-table td { padding: 3px 6px; border-bottom: 0.5px solid #e5e7eb; }
                .pr-table tr.total td { border-top: 1.5px solid #111827; border-bottom: none; font-weight: 800; background: #f3f4f6; }

                .pr-bar { display: flex; align-items: center; gap: 4px; min-width: 70px; }
                .pr-bar .track { flex: 1; height: 5px; background: #e5e7eb; border-radius: 3px; overflow: hidden; }
                .pr-bar .fill { height: 100%; background: #111827; border-radius: 3px; }
                .pr-bar .pct { font-size: 8.5px; color: #6b7280; width: 26px; text-align: right; }

                .pr-footer { margin-top: 12px; padding-top: 5px; border-top: 1px solid #d1d5db; display: flex; justify-content: space-between; font-size: 8.5px; color: #9ca3af; }
            `}</style>

            {/* ================= Print-only document ================= */}
            <div className="print-only">
                <PrintReport
                    reportData={reportData}
                    summary={summary}
                    centerName={selectedCenterName}
                    dateLabel={dateLabel}
                />
            </div>

            <div className="no-print">
                <Getbalance />
            </div>

            {/* ================= Dashboard Filter Header (Improved) ================= */}
            <div className="no-print relative z-30 overflow-visible rounded-b-2xl border border-brand-100 bg-white shadow-sm hover:shadow-md">

                {/* Top accent strip — radius card ke inner curve se match karta hai (1rem - 1px border) */}
                <div className="h-1 w-full rounded-t-[calc(1rem-1px)] bg-gradient-to-r from-brand-500 via-brand-400 to-sky-300" />

                <div className="p-4 sm:p-5">

                    {/* ---------- Header row ---------- */}
                    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
                        <div className="flex items-center gap-3">
                            {/* Icon badge */}
                            <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-brand-500 to-brand-600 text-white shadow-md shadow-brand-500/25">
                                <HiDocumentReport className="text-2xl" />
                            </div>
                            <div>
                                <h2 className="text-lg font-bold leading-tight tracking-tight text-gray-900 sm:text-xl">
                                    Dashboard
                                </h2>
                                <p className="mt-0.5 flex items-center gap-1.5 text-xs text-gray-500">
                                    <FiCalendar className="shrink-0 text-brand-500" />
                                    {dateLabel}
                                </p>
                            </div>
                        </div>

                        <div className="flex shrink-0 items-center gap-2">
                            {!IsMobileEnv && (
                                <button
                                    onClick={doPrint}
                                    disabled={loding}
                                    title="Print report"
                                    aria-label="Print report"
                                    className="group flex h-10 items-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 text-sm font-medium text-gray-700 shadow-sm transition-all hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    <FiPrinter className="transition-transform group-hover:-translate-y-0.5" />
                                    <span className="hidden sm:inline">Print</span>
                                </button>
                            )}
                            <button
                                onClick={doRefresh}
                                disabled={loding}
                                title="Refresh"
                                aria-label="Refresh report"
                                className="grid h-10 w-10 place-items-center rounded-xl border border-gray-200 bg-white text-gray-600 shadow-sm transition-all hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                <FiRefreshCcw className={loding ? "animate-spin" : ""} />
                            </button>
                        </div>
                    </div>

                    {/* ---------- Filters ---------- */}
                    <div className="rounded-xl border border-gray-100 bg-gray-50/60 p-3 sm:p-4">
                        <div className="grid grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-[auto_1fr_1.3fr_auto] lg:gap-4">

                            {/* View — segmented toggle (sirf 2 options, isliye select ki jagah toggle) */}
                            <div className="w-full lg:w-auto">
                                <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                                    View
                                </label>
                                <div className="inline-flex w-full rounded-xl border border-gray-200 bg-white p-1 shadow-sm lg:w-auto" role="tablist">
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={searchType === 0}
                                        onClick={() => setSearchType(0)}
                                        className={`flex flex-1 items-center justify-center gap-1.5 rounded-lg px-4 py-1.5 text-sm font-medium transition-all lg:flex-none ${searchType === 0
                                            ? "bg-brand-600 text-white shadow-sm"
                                            : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                                            }`}
                                    >
                                        <HiDocumentReport className="text-base" />
                                        All
                                    </button>
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={searchType === 1}
                                        onClick={() => setSearchType(1)}
                                        className={`flex flex-1 items-center justify-center gap-1.5 rounded-lg px-4 py-1.5 text-sm font-medium transition-all lg:flex-none ${searchType === 1
                                            ? "bg-brand-600 text-white shadow-sm"
                                            : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                                            }`}
                                    >
                                        <FaClinicMedical className="text-sm" />
                                        Centers
                                    </button>
                                </div>
                            </div>

                            {/* Center (conditional) */}
                            {searchType !== 0 ? (
                                <div className="w-full animate-[fadeIn_0.2s_ease-out]">
                                    <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                                        Center
                                    </label>
                                    <Select
                                        Icon={<FaClinicMedical className="text-lg text-red-500" />}
                                        value={selectedCenter}
                                        onChange={(e) => setSelectedCenter(e.target.value)}
                                    >
                                        <option value={0}>Select center…</option>
                                        {centerData.map(item => (
                                            <option key={item.id} value={item.id}>{item.centerName}</option>
                                        ))}
                                    </Select>
                                </div>
                            ) : (
                                <div className="hidden lg:block" aria-hidden="true" />
                            )}

                            {/* Date range */}
                            <div className="relative z-50 w-full">
                                <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                                    Date range
                                </label>
                                <Datepicker
                                    popoverDirection="down"
                                    displayFormat="DD/MM/YYYY"
                                    readOnly={true}
                                    separator="to"
                                    primaryColor="sky"
                                    value={value}
                                    onChange={newValue => setValue(newValue)}
                                    showShortcuts={true}
                                    containerClassName="relative z-[100]"
                                    inputClassName="w-full rounded-xl border border-gray-200 bg-white p-2.5 text-sm text-gray-900 shadow-sm outline-none transition focus:border-brand-400 focus:ring-2 focus:ring-brand-400/30"
                                />
                            </div>

                            {/* Search */}
                            <button
                                onClick={getReport}
                                disabled={loding}
                                className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-brand-600 to-brand-500 px-6 py-2.5 text-sm font-semibold text-white shadow-md shadow-brand-500/25 transition-all hover:from-brand-700 hover:to-brand-600 hover:shadow-lg hover:shadow-brand-500/30 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-300 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 disabled:shadow-none sm:col-span-2 lg:col-span-1 lg:w-auto"
                            >
                                {loding ? (
                                    <>
                                        <FiRefreshCcw className="h-4 w-4 animate-spin" />
                                        Loading…
                                    </>
                                ) : (
                                    <>
                                        <FiSearch className="h-4 w-4" />
                                        Search
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= Summary strip ================= */}
            <div className="no-print print-stats mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
                <StatTile
                    icon={<FaUserPlus />}
                    label="Registered"
                    value={summary.registered}
                    accent="bg-green-100 text-green-700"
                    loading={loding}
                />
                <StatTile
                    icon={<FaUserCheck />}
                    label="Confirmed"
                    value={summary.confirmed}
                    accent="bg-brand-100 text-brand-700"
                    loading={loding}
                />
                <StatTile
                    icon={<HiOutlineSquares2X2 />}
                    label="Sources"
                    value={summary.sources}
                    accent="bg-amber-100 text-amber-700"
                    loading={loding}
                />
                <StatTile
                    icon={<HiOutlineTag />}
                    label="Types"
                    value={summary.types}
                    accent="bg-purple-100 text-purple-700"
                    loading={loding}
                />
            </div>

            {/* ================= Report cards ================= */}
            <div className="no-print w-full pt-6">
                {loding ? (
                    <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2">
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                    </div>
                ) : (
                    <div className="print-grid grid w-full grid-cols-1 gap-6 md:grid-cols-2">

                        {/* All Registered */}
                        <div className="print-card">
                            <Card isBorder={true} borderColor="border-green-400" title={"All Registered Patient"}>
                                <ReportSection
                                    rows={reportData.registeredGlobal}
                                    chartData={reportData.registeredGlobal.map(i => ({
                                        label: <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} />,
                                        colorClass: ESourceBg(i.source),
                                        value: i.count,
                                    }))}
                                    columns={[
                                        { header: "Source", render: (i) => <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} /> },
                                        { header: "Count", render: (i) => i.count, numeric: true },
                                    ]}
                                />
                            </Card>
                        </div>

                        {/* All Confirmed */}
                        <div className="print-card">
                            <Card isBorder={true} borderColor="border-green-400" title={"All Confirmed Patient"}>
                                <ReportSection
                                    rows={reportData.confirmedGlobal}
                                    chartData={reportData.confirmedGlobal.map(i => ({
                                        label: (
                                            <span className="flex flex-wrap items-center gap-1">
                                                <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} />
                                                <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} />
                                            </span>
                                        ),
                                        colorClass: ESourceBg(i.source),
                                        value: i.count,
                                    }))}
                                    columns={[
                                        { header: "Source", render: (i) => <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} /> },
                                        { header: "Type", render: (i) => <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} /> },
                                        { header: "Count", render: (i) => i.count, numeric: true },
                                    ]}
                                />
                            </Card>
                        </div>

                        {/* Confirmed by Source */}
                        <div className="print-card">
                            <Card isBorder={true} borderColor="border-brand-300" title={"Confirmed Patient by Source"}>
                                <ReportSection
                                    rows={reportData.confirmedSource}
                                    chartData={reportData.confirmedSource.map(i => ({
                                        label: <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} />,
                                        colorClass: ESourceBg(i.source),
                                        value: i.count,
                                    }))}
                                    columns={[
                                        { header: "Source", render: (i) => <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} /> },
                                        { header: "Count", render: (i) => i.count, numeric: true },
                                    ]}
                                />
                            </Card>
                        </div>

                        {/* Confirmed by Type */}
                        <div className="print-card">
                            <Card isBorder={true} borderColor="border-brand-300" title={"Confirmed Patient by Type"}>
                                <ReportSection
                                    rows={reportData.confirmedType}
                                    chartData={reportData.confirmedType.map(i => ({
                                        label: <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} />,
                                        colorClass: ETypeBg(i.type),
                                        value: i.count,
                                    }))}
                                    columns={[
                                        { header: "Type", render: (i) => <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} /> },
                                        { header: "Count", render: (i) => i.count, numeric: true },
                                    ]}
                                />
                            </Card>
                        </div>
                    </div>
                )}
            </div>
        </ContainerTwo>
    )
}

/* ================================================================
   Small presentational pieces
   ================================================================ */

/* ---------- compact print-only report document ---------- */
function PrintReport({ reportData, summary, centerName, dateLabel }) {
    return (
        <div className="pr-doc">
            {/* Header */}
            <div className="pr-header">
                <div>
                    <h1 className="pr-title">Patient Report</h1>
                    <p className="pr-sub">OPD Registration &amp; Confirmation Summary</p>
                </div>
                <div className="pr-meta">
                    <div><b>Center:</b> {centerName}</div>
                    <div><b>Period:</b> {dateLabel}</div>
                    <div><b>Printed:</b> {moment().format("DD/MM/YYYY hh:mm A")}</div>
                </div>
            </div>

            {/* Summary strip */}
            <div className="pr-stats">
                <div className="pr-stat"><div className="k">Registered</div><div className="v">{summary.registered}</div></div>
                <div className="pr-stat"><div className="k">Confirmed</div><div className="v">{summary.confirmed}</div></div>
                <div className="pr-stat"><div className="k">Sources</div><div className="v">{summary.sources}</div></div>
                <div className="pr-stat"><div className="k">Types</div><div className="v">{summary.types}</div></div>
            </div>

            {/* Four sections in 2-column grid */}
            <div className="pr-grid">
                <PrintTable
                    title="Registered Patients"
                    rows={reportData.registeredGlobal}
                    columns={[{ header: "Source", render: (i) => GetESourceName(i.source) }]}
                />
                <PrintTable
                    title="Confirmed Patients"
                    rows={reportData.confirmedGlobal}
                    columns={[
                        { header: "Source", render: (i) => GetESourceName(i.source) },
                        { header: "Type", render: (i) => GetETypeName(i.type) },
                    ]}
                />
                <PrintTable
                    title="Confirmed by Source"
                    rows={reportData.confirmedSource}
                    columns={[{ header: "Source", render: (i) => GetESourceName(i.source) }]}
                />
                <PrintTable
                    title="Confirmed by Type"
                    rows={reportData.confirmedType}
                    columns={[{ header: "Type", render: (i) => GetETypeName(i.type) }]}
                />
            </div>

            {/* Footer */}
            <div className="pr-footer">
                <span>Generated automatically — no signature required</span>
                <span>{moment().format("DD MMM YYYY")}</span>
            </div>
        </div>
    )
}

function PrintTable({ title, rows, columns }) {
    const safeRows = rows || [];
    const total = safeRows.reduce((s, i) => s + (i.count || 0), 0);
    return (
        <div className="pr-section">
            <h3>{title}</h3>
            <table className="pr-table">
                <thead>
                    <tr>
                        {columns.map((c, i) => <th key={i}>{c.header}</th>)}
                        <th className="num">Count</th>
                        <th style={{ width: "30%" }}>Share</th>
                    </tr>
                </thead>
                <tbody>
                    {safeRows.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length + 2} style={{ color: "#9ca3af", fontStyle: "italic" }}>
                                No data for this period
                            </td>
                        </tr>
                    ) : (
                        safeRows.map((item, ri) => {
                            const pct = total ? Math.round((item.count / total) * 100) : 0;
                            return (
                                <tr key={ri}>
                                    {columns.map((c, ci) => <td key={ci}>{c.render(item)}</td>)}
                                    <td className="num">{item.count}</td>
                                    <td>
                                        <span className="pr-bar">
                                            <span className="track"><span className="fill" style={{ width: `${pct}%`, display: "block" }} /></span>
                                            <span className="pct">{pct}%</span>
                                        </span>
                                    </td>
                                </tr>
                            )
                        })
                    )}
                    <tr className="total">
                        <td colSpan={columns.length}>Total</td>
                        <td className="num">{total}</td>
                        <td />
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

/* ---------- summary stat tile ---------- */
function StatTile({ icon, label, value, accent, loading }) {
    return (
        <div className="flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-3.5  transition hover:-translate-y-0.5 shadow-sm hover:shadow-md sm:p-4">
            <div className={`grid h-10 w-10 shrink-0 place-items-center rounded-xl text-lg ${accent}`}>
                {icon}
            </div>
            <div className="min-w-0">
                <p className="truncate text-[11px] font-semibold uppercase tracking-wide text-gray-400">{label}</p>
                {loading ? (
                    <div className="mt-1 h-5 w-12 animate-pulse rounded bg-gray-100" />
                ) : (
                    <p className="text-xl font-bold leading-tight text-gray-800">{value}</p>
                )}
            </div>
        </div>
    )
}

/* ---------- skeleton card shown while loading ---------- */
function SkeletonCard() {
    return (
        <div className="animate-pulse rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
            <div className="mb-5 h-4 w-2/5 rounded bg-gray-100" />
            {[...Array(3)].map((_, i) => (
                <div key={i} className="mb-4">
                    <div className="mb-2 flex justify-between">
                        <div className="h-3 w-24 rounded bg-gray-100" />
                        <div className="h-3 w-10 rounded bg-gray-100" />
                    </div>
                    <div className="h-2.5 w-full rounded-full bg-gray-100" />
                </div>
            ))}
            <div className="mt-6 h-24 w-full rounded-xl bg-gray-50" />
        </div>
    )
}

/* ---------- chart + table combo with shared empty state ---------- */
function ReportSection({ rows, chartData, columns }) {
    const total = (rows || []).reduce((sum, item) => sum + (item.count || 0), 0);

    if (!rows || rows.length === 0) {
        return (
            <div className="py-8">
                <Empty>
                    <div className="text-base font-medium text-gray-500">No data for this period</div>
                    <div className="mt-1 text-sm text-gray-400">Try a different date range or center.</div>
                </Empty>
            </div>
        )
    }

    return (
        <>
            <div className="mb-4 flex items-center justify-between">
                <span className="text-xs font-semibold uppercase tracking-wide text-gray-400">Breakdown</span>
                <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-bold text-gray-700">
                    Total: {total}
                </span>
            </div>
            <BarChart data={chartData} />
            <ReportTable columns={columns} rows={rows} total={total} />
        </>
    )
}

/* ---------- horizontal bar chart (zero-dependency) ---------- */
function BarChart({ data }) {
    if (!data || data.length === 0) return null
    const max = Math.max(...data.map(d => d.value), 1)
    const total = data.reduce((s, d) => s + d.value, 0)
    return (
        <div className="mb-5 space-y-3.5">
            {data.map((d, i) => {
                const pct = total ? Math.round((d.value / total) * 100) : 0
                return (
                    <div key={i}>
                        <div className="mb-1.5 flex items-center justify-between gap-2 text-xs">
                            <span className="min-w-0">{d.label}</span>
                            <span className="shrink-0 font-semibold tabular-nums text-gray-700">
                                {d.value}
                                <span className="ml-1 font-normal text-gray-400">({pct}%)</span>
                            </span>
                        </div>
                        <div className="h-2.5 w-full overflow-hidden rounded-full bg-gray-100">
                            <div
                                className={`h-full rounded-full transition-[width] duration-700 ease-out ${d.colorClass}`}
                                style={{ width: `${(d.value / max) * 100}%` }}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

/* ---------- reusable report table ---------- */
function ReportTable({ columns, rows, total }) {
    return (
        <div className="overflow-x-auto rounded-xl ring-1 ring-gray-100">
            <table className="w-full border-collapse text-left text-sm text-gray-500">
                <thead>
                    <tr className="border-b border-gray-100 bg-slate-50 text-xs uppercase tracking-wide text-gray-500">
                        {columns.map((c, i) => (
                            <th
                                key={i}
                                scope="col"
                                className={`px-4 py-3 font-semibold sm:px-5 ${c.numeric ? "text-right" : ""}`}
                            >
                                {c.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                    {rows.map((item, ri) => (
                        <tr key={ri} className="bg-white transition-colors hover:bg-brand-50/40">
                            {columns.map((c, ci) => (
                                <td
                                    key={ci}
                                    className={`px-4 py-2.5 sm:px-5 ${c.numeric ? "text-right font-medium tabular-nums text-gray-700" : ""}`}
                                >
                                    {c.render(item)}
                                </td>
                            ))}
                        </tr>
                    ))}
                    <tr className="bg-gray-50 font-semibold text-gray-800">
                        <td className="px-4 py-2.5 text-right sm:px-5" colSpan={columns.length - 1}>Total</td>
                        <td className="px-4 py-2.5 text-right tabular-nums sm:px-5">{total}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}